//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Stars from './_stars'
export default {
    props: {
        plate: {
            type: Object
        }
    },
    data () {
        return {
            show_tip: false
        }
    },
    components: {
        Stars
    },
    methods:  {
        showTip () {
            this.show_tip = true
        }
    }
}
